import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, ContentChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinSizing, mixinChangeEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import { FadvIconComponent } from '@fa-switch-sharedservices/ng-elements/fadv-icon';
import '@fa-switch-sharedservices/web-elements/components/rating/rating';

class FadvRatingComponent extends mixinSizing(mixinChangeEvent(mixinFormControl(FadvBaseComponent))) {
    constructor(el) {
        super(el);
        /* The highest rating to display. */
        this.max = 5;
        /* The minimum increment value change allowed. */
        this.precision = 1;
        /* Makes the rating readonly. */
        this.readonly = false;
        /* The size of the rating. */
        this.size = 'medium';
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => (this.value = value));
        this.registerSubscription(this.changed, () => {
            this.reportChange(this.elementRef.nativeElement.value);
            this.onTouched();
        });
        const defaultGetSymbol = this.elementRef.nativeElement.getSymbol;
        this.elementRef.nativeElement.getSymbol = (value) => {
            var _a;
            if (this.icons.length === 1) {
                return this.icons.first.elementRef.nativeElement.outerHTML;
            }
            if (this.icons.length === this.elementRef.nativeElement.max) {
                return (_a = this.icons.get(value - 1)) === null || _a === void 0 ? void 0 : _a.elementRef.nativeElement.outerHTML;
            }
            return defaultGetSymbol(value);
        };
    }
}
FadvRatingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvRatingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvRatingComponent, selector: "fadv-rating", inputs: { value: "value", disabled: "disabled", max: "max", precision: "precision", readonly: "readonly", size: "size", helpText: "helpText", label: "label" }, outputs: { valueChange: "valueChange" }, providers: [createFormControlProvider(FadvRatingComponent)], queries: [{ propertyName: "icons", predicate: FadvIconComponent }], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvRatingComponent.prototype, "max", void 0);
__decorate([
    Forward()
], FadvRatingComponent.prototype, "precision", void 0);
__decorate([
    Forward()
], FadvRatingComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvRatingComponent.prototype, "size", void 0);
__decorate([
    Forward()
], FadvRatingComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvRatingComponent.prototype, "label", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-rating',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvRatingComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { max: [{
                type: Input
            }], precision: [{
                type: Input
            }], readonly: [{
                type: Input
            }], size: [{
                type: Input
            }], helpText: [{
                type: Input
            }], label: [{
                type: Input
            }], icons: [{
                type: ContentChildren,
                args: [FadvIconComponent]
            }] } });

class FadvRatingModule {
}
FadvRatingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvRatingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingModule, declarations: [FadvRatingComponent], imports: [FadvCommonModule], exports: [FadvRatingComponent] });
FadvRatingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvRatingComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvRatingComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvRatingComponent, FadvRatingModule };
